<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-dialog persistent v-model="dialog" width="1000px" :fullscreen="$vuetify.breakpoint.xsOnly">
    <component :userAccountId="this.userAccountId" v-bind:is="currentViewComponent" v-on="handlers"></component>
    <v-card class="mt-2">
      <v-card-title class="py-6">
        <div class="text-h6 text-sm-h4">
          {{ language.t("UserManager.users") }}
        </div>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col class="px-0 d-flex align-center px-2" :md="3" :sm="6" :cols="12">
              <v-btn block color="primary" small @click="addUserBtnPress()" height="48">
                <v-icon>mdi-plus</v-icon>{{ language.t("UserManager.addUser") }}
              </v-btn>
            </v-col>
            <v-col class="px-0 d-flex align-center px-2" :md="3" :sm="6" :cols="6">
              <v-btn block color="error" small @click="deleteUser()" :disabled="selected.length === 0" height="48">
                <v-icon>mdi-delete</v-icon>{{ language.t("UserManager.removeUser") }}
              </v-btn>
            </v-col>
            <v-col class="px-0 d-flex align-center px-2" :md="3" :sm="6" :cols="6">
              <v-btn block color="accent" small @click="editUserBtnPress()" :disabled="selected.length === 0" height="48">
                <v-icon>mdi-lead-pencil</v-icon>{{ language.t("UserManager.editUser") }}
              </v-btn>
            </v-col>
            <v-col class="pa-0 d-flex align-center px-2" :md="3" :sm="6" :cols="12">
              <v-text-field v-model="searchInput" class="pt-5 mr-2" solo
                :placeholder="language.t('UserManager.searchUser')" prepend-inner-icon="mdi-magnify">
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-spacer></v-spacer>
        <div>
          <v-data-table v-model="selected" :loading="loading" :headers="headers" :items="items" :items-per-page="5"
            :single-select="singleSelect" item-key="userId" :search="searchInput" :custom-filter="searchUsers"
            @click:row="selectUser" :footer-props="{
                itemsPerPageText: language.t('DataTables.itemsPerPageText'),
                itemsPerPageAllText: language.t('DataTables.itemsPerPageAllText'),
              }"><template v-slot:[`footer.page-text`]="items">
              {{ items.pageStart }} - {{ items.pageStop }}
              {{ language.t("DataTables.pageText") }} {{ items.itemsLength }}
            </template>
          </v-data-table>
        </div>
      </v-card-text>
      <v-card-actions class="card-actions">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('close')">
          <v-icon>mdi-close</v-icon>{{ language.t("App.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CustomerUserAdd from "./CustomerUserAdd";
import CustomerUserEdit from "./CustomerUserEdit";

export default {
  components: {
    CustomerUserAdd,
    CustomerUserEdit,
  },
  props: {},
  data() {
    return {
      dialog: true,
      searchInput: "",
      currentViewComponent: null,
      loading: true,
      singleSelect: true,
      selected: [],
      headers: [
        { text: this.language.t("UserManager.name"), value: "fullName" },
        {
          text: this.language.t("UserManager.emailAddress"),
          value: "emailAddress",
        },
        {
          text: this.language.t("UserManager.phoneNumber"),
          value: "mobilePhoneNumber",
        },
      ],
      items: [],
      userAccountId: null,
      dialog: true,
      handlers: {
        close: this.closeComponent,
        update: this.getCustomerUsers,
      },
    };
  },
  mounted: function () {
    this.getCustomerUsers();

    if (this.$auth.subscription == '__SUB_CIVIL_VECTOR') {
      this.headers.push({ text: this.language.t('Vector.MailNotifications'), value: "mail" }, { text: this.language.t('Vector.SMSNotifications'), value: "sms" })
      console.log(this.headers);
    }
  },
  computed: {
    customerId() {
      return this.$auth.customerId;

    },
  },
  watch: {},
  methods: {
    searchUsers(items, search, filter) {
      for (const key in filter) {
        if (
          search
            .toLowerCase()
            .split(" ")
            .every((v) => filter[key].toString().toLowerCase().includes(v))
        ) {
          return items;
        }
      }
    },
    getCustomerUsers() {

      var _this = this;
      _this.items = [];
      _this.loading = true;

      this.$axios.get(route("api.user.customer.users")).then((res) => {
        console.log(res.data);
          for (let i = 0; i < res.data.length; i++) {
            this.$axios.get(route('api.user.preference', res.data[i].userId)).then((result) =>{
              _this.items.push({
                userId: res.data[i].userId,
                userAccountId: res.data[i].account.accountId,
                firstName: res.data[i].firstName,
                lastName: res.data[i].lastName,
                fullName: res.data[i].lastName + (res.data[i].firstName ? ", " + res.data[i].firstName : "") + (res.data[i].middleName ? " " + res.data[i].middleName : ""),
                emailAddress: res.data[i].emailAddress,
                mail: (result.data.mail_notif === 1),
                sms: (result.data.sms_notif === 1),
                mobilePhoneNumber: res.data[i].mobilePhoneNumber || this.language.t("UserManager.phoneNumberUnknown"),
              });
            });
          }
        _this.loading = false;
      });
    },
    selectUser(item, row) {
      let selectState = row.isSelected ? false : true;
      row.select(selectState);

      if (selectState) {
        this.userAccountId = item.userAccountId;
      } else {
        this.userAccountId = null;
      }
    },
    deleteUser() {
      if (this.items.length > 1 && this.userAccountId) {
        this.$axios
          .post(route("api.user.customer.users.remove", this.userAccountId))
          .then((res) => {
            console.log(res);
            this.success = true;
            this.getCustomerUsers();
          })
          .catch((error) => {
            this.saving = false;
            console.log(error.response.data);
            if (error.response.data.error) this.error = error.response.data.error;
            else this.error = "unknown server error";
          });
      } else {
        console.log("cant delete last user");
      }
    },
    addUserBtnPress() {
      console.log("Add user");
      this.currentViewComponent = CustomerUserAdd;
    },
    editUserBtnPress() {
      console.log("Edit user");
      this.currentViewComponent = CustomerUserEdit;
    },
    closeComponent() {
      this.currentViewComponent = null;
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.v-data-table >>> .v-data-table__selected {
  background: #8dbde4 !important;
}
</style>


